export enum Licences {
  WatermarkNexguardCivolution = "WatermarkNexguardCivolution",
  CustomersManagement = "CustomersManagement",
  CatalogManagement = "CatalogManagement",
  RightsManagement = "RightsManagement",
  UHDOutputTranscoding = "UHDOutputTranscoding",
  HDRStandardOutputTranscoding = "HDRStandardOutputTranscoding",
  HDRDoViOutputTranscoding = "HDRDoViOutputTranscoding",
  DolbyAc3Decoding = "DolbyAc3Decoding",
  DolbyAc3Encoding = "DolbyAc3Encoding",
  OrderFileAttachment = "OrderFileAttachment",
  ImageSequenceProxyTranscode = "ImageSequenceProxyTranscode",
  RightManagementAllowsFaspexSendWithoutDealCheck = "RightManagementAllowsFaspexSendWithoutDealCheck",
  WatermarkForceOutput = "WatermarkForceOutput",
  TimeTool = "TimeTool",
  ConnectLink = "ConnectLink",
  ScribeTool = "ScribeTool",
  PlanningUserTaskKanban = "PlanningUserTaskKanban",
  PlanningUserTaskCalendar = "PlanningUserTaskCalendar",
  NormalizerTool = "NormalizerTool",
  DeliverySwitchRecentToTranscodeWatermark = "DeliverySwitchRecentToTranscodeWatermark",
  NormalizerToolUseMezzAuto = "NormalizerToolUseMezzAuto",
  BundleMakerCore = "BundleMakerCore",
  BundleMakerMetadata = "BundleMakerMetadata",
  PlayerScreenshotFromHires = "PlayerScreenshotFromHires",
  DcpTranscoding = "DcpTranscoding",
  QuoteManagement = "QuoteManagement",
  TranscodingGenericBasketFeature = "TranscodingGenericBasketFeature",
  TranscodingByProfileBasketFeature = "TranscodingByProfileBasketFeature",
  DcpKDMFeature = "DcpKDMFeature",
  YoutubeAntipiracyBasketFeature = "YoutubeAntipiracyBasketFeature",
  Drive = "Drive",
  DcpGlobecast = "DcpGlobecast",
  AWSConnector = "AWSConnector",
  TimetoolCompilation = "TimetoolCompilation",
  AccountManager = "AccountManager",
  ShareScreening = "ShareScreening",
  PlayTelestreamSwitch = "PlayTelestreamSwitch",
  ArchiveHeritageTape = "ArchiveHeritageTape",
  IngestMeasureAudioLoudness = "IngestMeasureAudioLoudness",
  MultiFactorAuthentication = "MultiFactorAuthentication",
  DolbyAtmosRendering = "DolbyAtmosRendering",
}
